import { Order } from "../ordering/ordering.js";
const order = new Order();
window.order = order;

import { Auth } from "../auth/auth.js";
const auth = new Auth();
window.auth = auth;

import { Profile } from "../profile/profile.js";
const profile = new Profile();
window.profile = profile;

import { Catalog } from "../catalog/catalog.js";
const catalog = new Catalog();
window.catalog = catalog;

import { Cookie } from "../cookie/cookie.js";
const cookie = new Cookie();
window.cookie = cookie;

order.applyEvents();

document.querySelector("body").addEventListener("mousemove", eyesRotate);
function eyesRotate() {
	const eye = document.querySelectorAll(".eye");
	eye.forEach(function (eye) {
		let x = (eye.getBoundingClientRect().left) + (eye.clientWidth / 2);
		let y = (eye.getBoundingClientRect().top) + (eye.clientHeight / 2);

		let radian = Math.atan2(event.clientX - x, event.clientY - y);
		let rotRight = (radian * (180 / Math.PI) * -1) + 0;
		let rotLeft = (radian * (180 / Math.PI) * -1) + 0;

		if (eye.classList.contains("eye--right")) {
			eye.style.transform = "rotate(" + rotRight + "deg)";
		}
		if (eye.classList.contains("eye--left")) {
			eye.style.transform = "rotate(" + rotLeft + "deg)";
		}
		for (var i = 0; i < eye.length; ++i) {
			eye[i].classList.add("active");
		}
	});
};

// app heights
const doc = document.documentElement
const header = document.querySelector(".header");
const headerLogoMob = document.querySelector(".header__mob .header__logo");
const headerLogoDes = document.querySelector(".header__des .header__logo");
const userFavoritesMob = document.querySelector(".header__mob .user-favorites");
const userCartMob = document.querySelector(".header__mob .user-cart");
const userFavoritesDes = document.querySelector(".header__des .user-favorites");
const userCartDes = document.querySelector(".header__des .user-cart");
const appSizes = () => {
	let windowHeight = $(window).height();
	doc.style.setProperty('--app-height', windowHeight + "px");
	if (header) {
		let headerHeight = header.offsetHeight;
		doc.style.setProperty('--header-height', headerHeight + "px");
	}
	if (headerLogoMob) {
		let headerLogoMobWidth = headerLogoMob.offsetWidth;
		header.style.setProperty('--header-logo-mob-width', headerLogoMobWidth + "px");
	}
	if (headerLogoDes) {
		let headerLogoDesWidth = headerLogoDes.offsetWidth;
		header.style.setProperty('--header-logo-des-width', headerLogoDesWidth + "px");
	}
	if (userFavoritesMob) {
		let userFavoritesMobWidth = userFavoritesMob.offsetWidth;
		header.style.setProperty('--user-favorites-mob-width', userFavoritesMobWidth + "px");
	}
	if (userCartMob) {
		let userCartMobWidth = userCartMob.offsetWidth;
		header.style.setProperty('--user-cart-mob-width', userCartMobWidth + "px");
	}
	if (userFavoritesDes) {
		let userFavoritesDesWidth = userFavoritesDes.offsetWidth;
		header.style.setProperty('--user-favorites-des-width', userFavoritesDesWidth + "px");
	}
	if (userCartDes) {
		let userCartDesWidth = userCartDes.offsetWidth;
		header.style.setProperty('--user-cart-des-width', userCartDesWidth + "px");
	}
}
appSizes();

window.onload = function () {
	// delete_cookie('str_city')
	// delete_cookie('city_kladr_id')
	if ($('.ordering-delivery__choose').length) {
		if (!cookie.get('sdek_id')) {
			$.getJSON('https://api.ipify.org?format=json', function (data) {
				let url = 'https://suggestions.dadata.ru/suggestions/api/4_1/rs/iplocate/address?ip='
				let token = '9b7035e8a3a10d58dcee12c839033bb60c01d340'
				let query = data.ip
				let options = {
					method: 'GET',
					mode: 'cors',
					headers: {
						'Content-Type': 'application/json',
						'Accept': 'application/json',
						'Authorization': 'Token ' + token
					}
				}
				fetch(url + query, options).then(response => response.text()).then(result => {
					if (JSON.parse(result).location.value.toString() != undefined) {
						cookie.set('str_city', JSON.parse(result).location.value.toString())
						cookie.set('city_kladr_id', JSON.parse(result).location.data.kladr_id.toString())
						cookie.set('geo_lat', JSON.parse(result).location.data.geo_lat.toString())
						cookie.set('geo_lon', JSON.parse(result).location.data.geo_lon.toString())

						$('input[name="str_city"]').val(cookie.get('str_city'))
						order.calcTarifs(cookie.get('city_kladr_id'), 'kladr')
					}
				})
				// fetch(url + query, options).then(response => response.text()).then(result => console.log(result)).catch(error => console.log('error', error))
			})
		}
		else {
			$('input[name="str_city"]').val(cookie.get('str_city'))
			order.calcTarifs(cookie.get('sdek_id'), 'sdek')
		}
	}
}

// is touch
function isTouchDevice() {
	return (("ontouchstart" in window) || (navigator.maxTouchPoints > 0) || (navigator.msMaxTouchPoints > 0));
}

if (isTouchDevice()) {
	$("body").removeClass("des");
	$("body").addClass("mob");
} else {
	$("body").removeClass("mob");
	$("body").addClass("des");
}


// Cookie
if ($('.cookie').length) {
	var myProj = myProj || {}
	myProj.cookiePolicy = function (__M) {
		var cookiePolicy = document.querySelector('.cookie'),
			acceptCookieBtn = cookiePolicy.querySelector('.cookie__main-button');

		acceptCookieBtn.addEventListener('click', function () {
			acceptCookie();
		});

		if (!cookie.get('cookie_notice_accepted')) {
			cookiePolicy.classList.add('active');
		}

		function acceptCookie() {
			if (!cookie.get('cookie_notice_accepted')) {
				cookiePolicy.classList.add('active');
				// set cookie
				var d = new Date();
				d.setTime(d.getTime() + (365 * 24 * 60 * 60 * 1000));
				cookie.set('cookie_notice_accepted', 'true', { path: '/', expires: d });
			}

			if (cookiePolicy) {
				cookiePolicy.classList.remove('active');
				setTimeout(function () {
					cookiePolicy.parentNode.removeChild(cookiePolicy);
					cookiePolicy = null;
				}, 400);
			}
		}
	}(myProj);
}


// window scroll
$(window).on("scroll", function () {
	if ($(this).scrollTop() > 0) {
		$(".header").addClass("scrolled");
	} else {
		$(".header").removeClass("scrolled");
	};

	changeBgColor();

	setGoodsAdditionalPosition();
	setOrderingSummaryPosition();

	if ($(".profile__nav").length) {
		setProfileNavPosition();
		checkProfileNavSticky();
	}
});


// window resize
$(window).on("resize", function () {
	// app heights
	appSizes();

	if (window.matchMedia("(min-width: 1024px)").matches) {
		if ($(".header__popup").hasClass("active")) {
			$("body").removeClass("no-scroll");
			$(".header__burger").removeClass("active");
			$(".header__popup").removeClass("active");
		}
	}

	changeBgColor();

	setGoodsAdditionalPosition();
	setOrderingSummaryPosition();

	if ($(".profile__nav").length) {
		setProfileNavPosition();
		checkProfileNavSticky();
	}
});

const bgColorItems = document.querySelectorAll(".bg-color-item");
const body = document.querySelector("body");
function changeBgColor() {
	for (let index = 0; index < bgColorItems.length; index++) {
		const bgColorItem = bgColorItems[index];
		const bgColorItemHeight = bgColorItem.offsetHeight;
		const bgColorItemOffsetTop = offset(bgColorItem).top;
		const bgColorItemBgColor = bgColorItem.getAttribute("data-bg");
		const animStart = 3;

		let bgColorItemPointY = window.innerHeight - bgColorItemHeight / animStart;

		if (bgColorItemHeight > window.innerHeight) {
			bgColorItemPointY = window.innerHeight - window.innerHeight / animStart;
		}

		if (pageYOffset > bgColorItemOffsetTop - bgColorItemPointY && pageYOffset < bgColorItemOffsetTop + bgColorItemHeight) {
			// Remove all classes on body with color-
			var el = document.querySelector('*[class*="bg-"]');
			for (let i = el.classList.length - 1; i >= 0; i--) {
				const className = el.classList[i];
				if (className.startsWith('bg-')) {
					el.classList.remove(className);
				}
			}
			// Add class of currently active div
			body.classList.add("bg-" + bgColorItemBgColor + "");
		}
	}
};
changeBgColor();

function offset(el) {
	const rect = el.getBoundingClientRect(),
		scrollTop = window.pageYOffset || document.documentElement.scrollTop,
		scrollLeft = window.pageXOffset || document.documentElement.scrollLeft;
	return {
		top: rect.top + scrollTop,
		left: rect.left + scrollLeft
	}
};

$(".header__burger").on("click", function () {
	$("body").toggleClass("no-scroll");
	$(this).toggleClass("active");
	$(".header__popup").toggleClass("active");
});

const moreMenu = document.querySelector('.js-p-target');
if (moreMenu) {
	priorityPlus(moreMenu, {
		innerToggleTemplate: "Ещё",
	});
}

$(document).on("click", function (e) {
	if ($(".header__popup").hasClass("active")) {
		var callbackPopup = $(".header__popup, .header__burger");
		if (!callbackPopup.is(e.target) && callbackPopup.has(e.target).length === 0) {
			$("body").removeClass("no-scroll");
			$(".header__burger").removeClass("active");
			$(".header__popup").removeClass("active");
		};
	}

	if ($(".mob .user-profile__menu").is(":visible")) {
		var callbackPopup = $(".user-profile")
		if (!callbackPopup.is(e.target) && callbackPopup.has(e.target).length === 0) {
			$(".user-profile__menu").removeClass("active");
		};
	}
});

$(".mob .user-profile__link").on("click", function (e) {
	e.preventDefault();
	$(this).siblings(".user-profile__menu").toggleClass("active");
});

$(".user-profile__button, .guest .ordering-data__login").on("click", function (e) {
	e.preventDefault();
	$("body").addClass("no-scroll");
	$(".popup-auth-tel").addClass("active");
});

$(".popup-auth__go-to-problems").on("click", function () {
	$(".popup-auth-problems").addClass("active");
});

$(".guest .main-nav__item-link--favorites, .guest .user-favorites, .guest .goods-additional__favorites, .guest .goods-card__favorites").on("click", function (e) {
	e.preventDefault();
	$("body").addClass("no-scroll");
	$(".popup-auth-tel").addClass("active");
});

$(".header__contacts-btn").on("click", function (e) {
	e.preventDefault();
	$("body").addClass("no-scroll");
	$(".popup-contacts").addClass("active");
});

// Popup
$(".open-yt").on("click", function (e) {
	e.stopPropagation();
	e.preventDefault();
	$("body").addClass("no-scroll");
	$(".popup-yt").addClass("active");
	$(".popup-yt__iframe").attr("src", "https://www.youtube.com/embed/" + $(this).attr("data-yt"));
});

$(".popup__close, .popup__btn-close").on("click", function (e) {
	$("body").removeClass("no-scroll");
	$(this).closest(".popup").removeClass("active");
	if ($(this).closest(".popup").hasClass("popup-yt")) {
		$(".popup-yt__iframe").attr("src", "");
	}
	if ($(this).closest(".popup").hasClass("popup-qr-payment") && location.pathname == '/ordering/') {
		window.location.replace("/lk/orders/" + cookie.get("orderId") + "/");
	}
});

$(".popup").on("click", function (e) {
	if ($(".popup-cdek").hasClass("active")) {
		return;
	}
	var callbackPopup = $(".popup__container");
	if (!callbackPopup.is(e.target) && callbackPopup.has(e.target).length === 0) {
		$(this).removeClass("active");
		$("body").removeClass("no-scroll");
		if ($(this).hasClass("popup-yt")) {
			$(".popup-yt__iframe").attr("src", "");
		}
		if ($(this).hasClass("popup-qr-payment") && location.pathname == '/ordering/') {
			window.location.replace("/lk/orders/" + cookie.get("orderId") + "/");
		}
	};
});


$(".test-steps__item-open-book").on("click", function (e) {
	$("body").addClass("no-scroll");
	$(".popup-demo").addClass("active");
});

// Features
$(".features-video:not(:first-of-type)").hide();
// $(".features-video:not(:first-of-type) .features-video__content").trigger('pause');
$(".features-caption__button").eq(0).addClass("active");
$(".features-caption__button").on("click", function () {
	if (!$(this).hasClass('active')) {
		$(".features-caption__button").removeClass("active");
		$(this).addClass("active");

		$(".features-video").hide();
		// $(".features-video  .features-video__content").trigger('pause');

		$(".features-video").eq($(this).index(".features-caption__button")).fadeIn();
		// $(".features-video .features-video__content").eq($(this).index(".features-caption__button")).trigger('play');
	}
});

$(".goods-card__add").on("click", function (e) {
	e.preventDefault();
});

$(".goods-card__to-cart").on("click", function (e) {
	e.preventDefault();
});

$(".goods-card__notify").on("click", function (e) {
	e.preventDefault();
	$("body").addClass("no-scroll");
	$(".popup-notify").addClass("active");
});

$(".user .goods-card__favorites, .user .goods-additional__favorites").on("click", function (e) {
	e.preventDefault();
	if ($(this).hasClass("active")) {
		$(this).removeClass("active");
		$(this).addClass("disactive");
		setTimeout(() => {
			$(this).removeClass("disactive");
		}, 400);
	} else if ($(this).hasClass("disactive")) {
		$(this).removeClass("disactive");
		$(this).addClass("active");
	} else {
		$(this).addClass("active");
	}
});

$(".goods-additional__notify").on("click", function (e) {
	e.preventDefault();
	$("body").addClass("no-scroll");
	$(".popup-notify").addClass("active");
});

$(".order-about__actions-cancel").on("click", function (e) {
	$(".popup-cancel-order__form").data('id', $(this).data('id'));
	$("body").addClass("no-scroll");
	$(".popup-cancel-order").addClass("active");
});

var swiperBanners = new Swiper('.discounts-banners__wrapper', {
	slidesPerView: 1,
	allowTouchMove: false,
	autoplay: {
		delay: 6000,
		disableOnInteraction: false,
		pauseOnMouseEnter: true,
	},
	watchOverflow: true,
	effect: 'fade',
	fadeEffect: {
		crossFade: true
	},
	navigation: {
		nextEl: '.discounts-banners__nav--next',
		prevEl: '.discounts-banners__nav--prev'
	}
});

var swiperDemoSlider = new Swiper('.popup-demo__slider', {
	slidesPerView: 1,
	watchOverflow: true,
	observer: true,
	observeParents: true,
	navigation: {
		nextEl: '.popup-demo__slider-nav--next',
		prevEl: '.popup-demo__slider-nav--prev'
	}
});

var swiperGoodsSlider = new Swiper('.goods-slider__container', {
	slidesPerView: 'auto',
	watchOverflow: true,
	observer: true,
	observeParents: true,
	spaceBetween: 16,
	navigation: {
		nextEl: '.goods-slider__nav--next',
		prevEl: '.goods-slider__nav--prev'
	},
	breakpoints: {
		768: {
			slidesPerView: 2,
			spaceBetween: 24
		},
		1024: {
			slidesPerView: 3,
			spaceBetween: 24
		},
		1280: {
			slidesPerView: 3,
			spaceBetween: 32
		},
		1440: {
			slidesPerView: 3,
			spaceBetween: 40
		}
	}
});

var swiperDiscountsMain = new Swiper('.discounts-main__container', {
	slidesPerView: 'auto',
	allowTouchMove: false,
	watchOverflow: true,
	observer: true,
	observeParents: true,
	spaceBetween: 16,
	navigation: {
		nextEl: '.discounts-main__nav--next',
		prevEl: '.discounts-main__nav--prev'
	},
	breakpoints: {
		768: {
			spaceBetween: 24
		},
		1024: {
			slidesPerView: 3,
			spaceBetween: 24
		},
		1280: {
			slidesPerView: 3,
			spaceBetween: 32
		},
		1440: {
			slidesPerView: 3,
			spaceBetween: 40
		}
	}
});

var swiperGoodsPageThumbs = new Swiper('.goods-page__thumbs-wrapper', {
	centeredSlides: true,
	centeredSlidesBounds: true,
	slidesPerView: 3,
	spaceBetween: 8,
	watchOverflow: true,
	observer: true,
	observeParents: true,
	watchSlidesProgress: true,
	navigation: {
		nextEl: '.goods-page__thumbs-nav--next',
		prevEl: '.goods-page__thumbs-nav--prev'
	},
	breakpoints: {
		768: {
			direction: 'vertical'
		},
		1440: {
			direction: 'horizontal',
			slidesPerView: 3
		}
	}
});

var swiperGoodsPageGallery = new Swiper('.goods-page__slider-wrapper', {
	slidesPerView: 'auto',
	spaceBetween: 8,
	watchOverflow: true,
	observer: true,
	observeParents: true,
	watchSlidesProgress: true,
	navigation: {
		nextEl: '.goods-page__slider-nav--next',
		prevEl: '.goods-page__slider-nav--prev'
	},
	breakpoints: {
		768: {
			spaceBetween: 16,
		},
	},
	thumbs: {
		swiper: swiperGoodsPageThumbs
	}
});

$(".discount-card__code").on("click", function (e) {
	e.preventDefault();

	var $tmp = $("<textarea>");
	$("body").append($tmp);
	$tmp.val($(this).text()).select();
	document.execCommand("copy");
	$tmp.remove();

	$(this).siblings(".discount-card__code-message").fadeIn(200).delay(1000).fadeOut(200);
});

$(".discount-card__code-message").on("click", function (e) {
	e.preventDefault();
});

$(".discount-banner__code").on("click", function (e) {
	e.preventDefault();

	var $tmp = $("<textarea>");
	$("body").append($tmp);
	$tmp.val($(this).text()).select();
	document.execCommand("copy");
	$tmp.remove();

	$(this).siblings(".discount-banner__code-message").fadeIn(200).delay(1000).fadeOut(200);
});

function setGoodsAdditionalPosition() {
	if (window.matchMedia("(min-width: 1024px)").matches) {
		if ($(".goods-page__additional").outerHeight() <= $(window).height() - ($(".header__top").outerHeight() + ($(".goods-page__teaser").outerHeight(true) - $(".goods-page__teaser").outerHeight()) + ($(".goods-page__teaser").outerHeight(true) - $(".goods-page__teaser").outerHeight()))) {
			$(".goods-page__additional").css("bottom", "");
			$(".goods-page__additional").css("position", "");
			$(".goods-page__additional").css("top", $(".header__top").outerHeight() + ($(".goods-page__teaser").outerHeight(true) - $(".goods-page__teaser").outerHeight()));
		} else {
			$(".goods-page__additional").css("position", "static");
		}
	} else {
		$(".goods-page__additional").css("top", "");
		$(".goods-page__additional").css("position", "");
		$(".goods-page__additional").css("bottom", ($(".goods-additional__info").outerHeight() + (($(".goods-page__additional").innerHeight() - $(".goods-page__additional").height()) / 2) + (($(".goods-page__additional").outerHeight() - $(".goods-page__additional").innerHeight()) / 2)) * -1);
	}
};
setGoodsAdditionalPosition();

function setProfileNavPosition() {
	if (window.matchMedia("(min-width: 1024px)").matches) {
		$(".profile__nav").css("top", $(".header__top").outerHeight() + (($(".profile").innerHeight() - $(".profile").height()) / 2));
	} else {
		$(".profile__nav").css("top", $(".header__mob").outerHeight());
	}
};

function checkProfileNavSticky() {
	if (window.matchMedia("(min-width: 1024px)").matches) {
		$(".profile__nav").removeClass("sticky");
	} else {
		var ProfileNavRect = document.querySelector(".profile__nav").getBoundingClientRect();
		if (ProfileNavRect.top <= $(".header").outerHeight()) {
			$(".profile__nav").addClass("sticky");
		} else {
			$(".profile__nav").removeClass("sticky");
		}
	}
};

if ($(".profile__nav").length) {
	setProfileNavPosition();
	checkProfileNavSticky();
}

function setOrderingSummaryPosition() {
	if (window.matchMedia("(min-width: 1024px)").matches) {
		if ($(".ordering__summary").outerHeight() > $(window).height() - ($(".header__top").outerHeight() + ($(".ordering").outerHeight() - $(".ordering").height()))) {
			$(".ordering__summary").css("position", "static");
		} else {
			$(".ordering__summary").css("position", "");
		}
	} else {
		$(".ordering__summary").css("position", "");
	}
};
setOrderingSummaryPosition();

profile.applyEvents();

// Tabs
$(".tabs__tab:not(:first-of-type)").hide();
$(".tabs__nav-item:first-of-type .tabs__nav-btn").addClass("active");
$(".tabs__nav-btn").on("click", function () {
	if (!$(this).hasClass('active')) {
		$(this).parent(".tabs__nav-item").siblings().children(".tabs__nav-btn").removeClass("active");
		$(this).addClass("active");
		$(this).parents(".tabs").find(".tabs__tab").hide();
		$(".tabs__tab").eq($(this).index(".tabs__nav-btn")).fadeIn();
	}
});

$(".support-qa__question").on("click", function () {
	$(".support-qa__question").not(this).siblings(".support-qa__answer").slideUp();
	$(".support-qa__question").not(this).removeClass("active");
	$(this).toggleClass("active");
	$(this).siblings(".support-qa__answer").slideToggle();
});

$(".delivery-info__section-toggler").on("click", function () {
	$(".delivery-info__section-toggler").not(this).siblings(".delivery-info__section-content").slideUp();
	$(".delivery-info__section-toggler").not(this).removeClass("active");
	$(this).toggleClass("active");
	$(this).siblings(".delivery-info__section-content").slideToggle();
});

// tel
function parsePhoneNumber() {
	var num = this.value
		.replace(/^(8|7|\+7\(7|\+7)/, "")
		.replace(/\D/g, "")
		.split(/(?=.)/),
		i = num.length
	if (0 <= i) num.unshift("+7")
	if (1 <= i) num.splice(1, 0, " (")
	if (4 <= i) num.splice(5, 0, ") ")
	if (7 <= i) num.splice(9, 0, "-")
	if (9 <= i) num.splice(12, 0, "-")
	if (11 <= i) num.splice(15, num.length - 15)
	this.value = num.join("")

	if (i < 10)
		this.setCustomValidity("Введен не полный номер телефона");
	else
		this.setCustomValidity("");
}

$.fn.formatPnoneNumber = function () {
	return this.each(function () {
		$(this).on("input", parsePhoneNumber)
	})
}

$("input[type=tel]").formatPnoneNumber();


// date
// function parseDate() {
// 	var num = this.value
// 		.replace(/\D/g, "")
// 		.split(/(?=.)/),
// 		i = num.length
// 	if (3 <= i) num.splice(2, 0, ".")
// 	if (5 <= i) num.splice(5, 0, ".")
// 	if (8 <= i) num.splice(10, num.length - 10)
// 	this.value = num.join("")
// }

// $.fn.formatDate = function () {
// 	return this.each(function () {
// 		$(this).on("input", parseDate)
// 	})
// }

// $("input[name^=dte]").formatDate();

$("input[name^=dte]").toArray().forEach(function (field) {
	new Cleave(field, {
		date: true,
		delimiter: '.',
		datePattern: ['d', 'm', 'Y'],
		onValueChanged: function (e) {
			if (e.target.value && !e.target.value.match(/\d{2}\.\d{2}\.\d{4}/))
				field.setCustomValidity("Введена не полная дата");
			else
				field.setCustomValidity("");
		}
	});
});
